import React, { useState } from 'react';
import { ReactComponent as CheckedIcon } from '../../assets/icons/CheckedIcon.svg';
import { ReactComponent as HalfCheckedIcon } from '../../assets/icons/HalfCheckedIcon.svg';
import { ReactComponent as FilterUnfoldIcon } from '../../assets/icons/FilterUnfoldIcon.svg';
import { ReactComponent as FilterFoldIcon } from '../../assets/icons/FilterFoldIcon.svg';
import { RowWrapper, LeftPart, CheckBox, NameWrapper, NameSpan, RightPart } from './SiteRow';
import SystemRow from './SystemRow';
import {
  ReportFilterData,
  ReportFilterState,
  ReportSystem,
  UserSystemGroupStrings,
} from 'store/storeTypes';
import { SinglePrinterSelectionPayload } from 'actions/reportFilterActions';
import { StyledTooltip } from '../_common/StyledTooltip';
import {
  HISTORICAL_MODEL_ID,
  HISTORICAL_SECTION_NAME,
  HISTORICAL_SITE_ID,
} from 'models/ReportsFilterData';

type HistoricalRowProps = {
  systems: ReportSystem[];
  selectedSystemGroup: UserSystemGroupStrings;
  filterState: ReportFilterState;
  filterData: ReportFilterData;
  isSingleSelectionMode: boolean;
  disabled?: boolean;
  toggleFilterRowSystemsSelection: ({}) => void;
  toggleFilterSerialRowSystemSelection: ({}) => void;
  singlePrinterSelection: ({}: SinglePrinterSelectionPayload) => void;
};

const HistoricalRow = ({
  systems,
  selectedSystemGroup,
  filterState,
  filterData,
  isSingleSelectionMode,
  disabled,
  toggleFilterRowSystemsSelection,
  toggleFilterSerialRowSystemSelection,
  singlePrinterSelection,
}: HistoricalRowProps) => {
  const [isFolded, setFolded] = useState(false);
  const allHistoricalSerials = filterData.systems
    .filter(system => system.isHistorical)
    .map(system => system.name);
  const selectedCount = filterState.selectedSystemSerials.filter(serial =>
    allHistoricalSerials.includes(serial)
  ).length;
  const isThisRowSelected = selectedCount > 0;

  const onClick = () => {
    if (disabled) return;
    if (!isSingleSelectionMode) {
      toggleFilterRowSystemsSelection({
        selectedSystemGroup,
        filterData,
        filterState,
        siteId: HISTORICAL_SITE_ID,
      });
    }
  };
  const checkedIcon =
    selectedCount === allHistoricalSerials.length ? (
      <CheckedIcon fill="white" />
    ) : (
      <HalfCheckedIcon fill="white" style={{ marginTop: '1px' }} />
    );
  const sortedSystems = [...systems].sort(
    (printer1, printer2) => +printer1.name.split('-').join('') - +printer2.name.split('-').join('')
  );

  return (
    <>
      <RowWrapper isSiteRow={true} data-testid="machine-filter-historical-row">
        <StyledTooltip
          title={disabled ? 'Production Hours are not available for historical printers' : ''}
          placement="top"
          arrow>
          <LeftPart onClick={onClick}>
            <CheckBox
              data-testid="historical-check-box"
              checked={isThisRowSelected}
              disabled={disabled}>
              {isThisRowSelected && checkedIcon}
            </CheckBox>
            <NameWrapper>
              <NameSpan data-testid="row-historical-name">{HISTORICAL_SECTION_NAME}</NameSpan>
            </NameWrapper>
          </LeftPart>
        </StyledTooltip>
        <RightPart onClick={() => setFolded(!isFolded)}>
          {isFolded ? <FilterUnfoldIcon /> : <FilterFoldIcon data-testid="historical-folded-icon" />}
        </RightPart>
      </RowWrapper>
      {!isFolded &&
        sortedSystems.map(system => (
          <SystemRow
            key={system.id}
            {...system}
            filterState={filterState}
            filterData={filterData}
            selectedSystemGroup={selectedSystemGroup}
            siteId={HISTORICAL_SITE_ID}
            modelId={HISTORICAL_MODEL_ID}
            isSingleSelectionMode={isSingleSelectionMode}
            disabled={disabled}
            singlePrinterSelection={singlePrinterSelection}
            toggleFilterSerialRowSystemSelection={toggleFilterSerialRowSystemSelection}
          />
        ))}
    </>
  );
};
export default HistoricalRow;
